import { useState } from 'react'

import { handleError } from '../../helpers/handleError.ts'
import { updateSocialMedia } from '../../services/socialMedia.ts'
import { Toggle } from '../Toggle'

interface SocialMediaToggleProps {
  id: string
  initialEnabled: boolean
}

export const SocialMediaToggle = ({
  id,
  initialEnabled,
}: SocialMediaToggleProps) => {
  const [enabled, setEnabled] = useState(initialEnabled)

  const handleToggle = async (newEnabled: boolean) => {
    setEnabled(newEnabled)

    try {
      await updateSocialMedia({ enabled: newEnabled }, id)
    } catch (error) {
      setEnabled(!newEnabled)
      handleError(error)
    }
  }

  return <Toggle enabled={enabled} onToggle={handleToggle} />
}
